import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=79824d53"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79824d53')) {
      api.createRecord('79824d53', component.options)
    } else {
      api.reload('79824d53', component.options)
    }
    module.hot.accept("./Overview.vue?vue&type=template&id=79824d53", function () {
      api.rerender('79824d53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Dashboard/Overview.vue"
export default component.exports